import dayjs from 'dayjs'

import type { State } from './types'

export const initialState: State = {
  filters: {
    groupNumber: undefined,
    dateFrom: undefined,
    dateTo: dayjs().format('YYYY-MM-DD'),
    checkNumber: undefined
  },
  pagination: {
    page: 1,
    pageSize: 50
  }
}

export type Action =
  | { type: 'filters/groupNumber/set'; payload?: string }
  | { type: 'filters/dateFrom/set'; payload?: string }
  | { type: 'filters/dateTo/set'; payload?: string }
  | { type: 'filters/checkNumber/set'; payload?: string }
  | { type: 'pagination/page/set'; payload: number }
  | { type: 'pagination/pageSize/set'; payload: number }
  | { type: 'filters/reset' }

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'filters/groupNumber/set':
      return {
        ...state,
        filters: { ...state.filters, groupNumber: action.payload },
        pagination: { ...state.pagination, page: 1 }
      }
    case 'filters/dateFrom/set':
      return {
        ...state,
        filters: { ...state.filters, dateFrom: action.payload },
        pagination: { ...state.pagination, page: 1 }
      }
    case 'filters/dateTo/set':
      return {
        ...state,
        filters: { ...state.filters, dateTo: action.payload },
        pagination: { ...state.pagination, page: 1 }
      }
    case 'filters/checkNumber/set':
      return {
        ...state,
        filters: { ...state.filters, checkNumber: action.payload },
        pagination: { ...state.pagination, page: 1 }
      }
    case 'pagination/page/set':
      return { ...state, pagination: { ...state.pagination, page: action.payload } }
    case 'pagination/pageSize/set':
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } }
    case 'filters/reset':
      return { ...initialState }
    default:
      return state
  }
}
